import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M23.3 8.896a6.13 6.13 0 0 0-5.279-3.03h-.498C16.03 1.564 11.35-.88 6.868.294 4.478.88 2.586 2.346 1.291 4.302-.004 6.256-.302 8.7.295 10.949c.399 1.369.996 2.542 1.992 3.617.398.39.996.49 1.394.098.398-.391.498-.977.1-1.37-.698-.781-1.295-1.76-1.494-2.834-.498-1.76-.2-3.52.796-5.18a6.63 6.63 0 0 1 4.283-3.13c3.684-.977 7.568 1.27 8.464 4.889.1.39.498.684.996.684h1.195c1.494 0 2.788.782 3.485 2.053.498.88.598 1.955.3 2.933-.3.978-.997 1.857-1.893 2.346-.498.293-.697.88-.398 1.369.199.293.498.489.896.489.2 0 .299 0 .498-.098 1.394-.782 2.39-1.955 2.888-3.52.398-1.368.201-3.03-.497-4.4m-10.557.196c-.1-.098-.199-.196-.299-.196-.199-.098-.498-.098-.796 0-.1.098-.2.098-.299.196l-3.983 3.91a.933.933 0 0 0 0 1.369.974.974 0 0 0 1.394 0l2.29-2.25v6.453c0 .587.399.978.996.978.598 0 .996-.391.996-.977v-6.453l2.29 2.249c.2.195.498.293.697.293.2 0 .498-.098.698-.293a.933.933 0 0 0 0-1.37z"
    }, null, -1)
  ]))]))
}
export default { render: render }